import type { SlideProps } from "@/engine/app/offsite-config";

const SVO_OS_URL = "https://dev.svoos.de";
/** Slide 8 (Slide08Ueberleitung) is the workshop entry. */
const WORKSHOP_BRIDGE_SLIDE = 8;

export function Slide01Titel({ onJump }: SlideProps) {
  const goTo = (slideNumber: number) => {
    if (onJump) onJump(slideNumber);
  };

  const openSvoOs = () => {
    window.open(SVO_OS_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <div className="deck-root" style={{ background: "var(--svo-dunkelblau)" }}>
      <div className="deck-bg" aria-hidden="true" />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 420,
          height: 420,
          top: "-80px",
          right: "-120px",
          background: "var(--svo-blau)",
          opacity: 0.35,
        }}
      />
      <div
        className="float"
        aria-hidden="true"
        style={{
          width: 320,
          height: 320,
          bottom: "-80px",
          left: "10%",
          background: "var(--svo-gruen)",
          opacity: 0.18,
          animationDelay: "4s",
        }}
      />

      <header className="deck-head">
        <div className="deck-eyebrow rise rise-1" style={{ color: "var(--svo-blau)" }}>
          SVO Offsite · April 2026
        </div>
        <h1
          className="deck-title rise rise-2"
          style={{ color: "#fff" }}
        >
          IT-Strategie <br />
          <span className="accent">des Vertriebs</span>
        </h1>
        <p
          className="deck-sub rise rise-3"
          style={{ color: "rgba(255,255,255,0.78)" }}
        >
          Mehr Zeit für das, was zählt — wie wir mit weniger Reibung bessere
          Ergebnisse liefern.
        </p>
      </header>

      <div className="deck-flow">
        <div className="chapter rise rise-4">
          <div className="chapter-num">01</div>
          <div className="chapter-title">
            Heute <span className="alt">verstehen</span>
          </div>
          <div className="chapter-desc">
            Wo wir stehen, was uns Zeit kostet, was wir gelernt haben.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Status Quo</div>
            <div className="chapter-arrow">→</div>
          </div>
        </div>

        <button
          type="button"
          className="chapter-bridge chapter-bridge-clickable rise rise-5"
          onClick={() => goTo(WORKSHOP_BRIDGE_SLIDE)}
          title={`Springe zu Folie ${WORKSHOP_BRIDGE_SLIDE} — Workshop-Bridge`}
        >
          <div className="chapter-bridge-pill">
            <span className="chapter-bridge-icon">⚡</span>
            <div className="chapter-bridge-text">
              <span className="chapter-bridge-eyebrow">Interaktiver Workshop</span>
              <span className="chapter-bridge-title">
                „Anforderungen an KI" — wie präzise könnt ihr werden?
              </span>
              <span className="chapter-bridge-action">→ Folie {WORKSHOP_BRIDGE_SLIDE}</span>
            </div>
          </div>
        </button>

        <button
          type="button"
          className="chapter chapter-clickable rise rise-5"
          onClick={() => goTo(10)}
          title="Springe zu Folie 10"
        >
          <div className="chapter-num">02</div>
          <div className="chapter-title">
            Morgen <span className="alt">bauen</span>
          </div>
          <div className="chapter-desc">
            KI-Bausteine — wo wir hinwollen.
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Plan · Folie 10</div>
            <div className="chapter-arrow">→</div>
          </div>
        </button>

        <button
          type="button"
          className="chapter-bridge chapter-bridge-clickable rise rise-6"
          onClick={openSvoOs}
          title="SVO OS in neuem Tab öffnen"
        >
          <div className="chapter-bridge-pill">
            <span className="chapter-bridge-icon">◆</span>
            <div className="chapter-bridge-text">
              <span className="chapter-bridge-eyebrow">SVO OS</span>
              <span className="chapter-bridge-title">
                Das Fundament, das schon steht.
              </span>
              <span className="chapter-bridge-action">↗ dev.svoos.de</span>
            </div>
          </div>
        </button>

        <button
          type="button"
          className="chapter chapter-clickable rise rise-6"
          onClick={() => goTo(15)}
          title="Springe zu Folie 15"
        >
          <div className="chapter-num">03</div>
          <div className="chapter-title">
            Zukunft <span className="alt">denken</span>
          </div>
          <div className="chapter-desc">
            Was wird in 12 Monaten möglich sein?
          </div>
          <div className="chapter-foot">
            <div className="chapter-meta">Vision · Folie 15</div>
            <div className="chapter-arrow">→</div>
          </div>
        </button>
      </div>

      <footer
        className="deck-foot"
        style={{ color: "rgba(255,255,255,0.55)" }}
      >
        <span>Viktor Lüders · IT Requirements Manager</span>
        <span>SVO Vertrieb GmbH · Celle · Uelzen</span>
      </footer>
    </div>
  );
}
